import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

function Icon(props: Props) {
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0.852578 0.622033C0.657315 0.42677 0.340733 0.42677 0.14547 0.622033C-0.049792 0.817295 -0.0497921 1.13388 0.14547 1.32914L5.99902 7.18269L11.8526 1.32914C12.0478 1.13388 12.0478 0.817297 11.8526 0.622034C11.6573 0.426772 11.3407 0.426772 11.1455 0.622034L5.99902 5.76848L0.852578 0.622033Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Icon;
